"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.repaymentTapePointerConfig = exports.repaymentFeedPointerMethod = exports.parafinDateFormat = void 0;
const lodash_1 = __importDefault(require("lodash"));
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
exports.parafinDateFormat = 'yyyy-MM-dd';
const repaymentFeedPointerMethod = ({ csvArray, assignedExternalReceivableIds, reportingDate, fileVersion, creditFacilityId, }) => {
    // repayment tape may be associated to master loan tape,
    // as such, we need to filter down repayment tape to just the set of receivables
    // that are in the assigned loan tape
    const idSet = new Set(assignedExternalReceivableIds);
    const filteredCsvArray = lodash_1.default.filter(csvArray, (csvRow) => idSet.has(csvRow.capital_product_id));
    const repaymentEffectiveAmountByDate = lodash_1.default.mapValues(lodash_1.default.groupBy(filteredCsvArray, (csvRow) => csvRow.payment_effective_date), (csvRows) => lodash_1.default.sumBy(csvRows, (csvRow) => lodash_1.default.isNaN(Number(csvRow.payment_effective_amount))
        ? 0
        : Number(csvRow.payment_effective_amount)));
    const dbRows = lodash_1.default.map(lodash_1.default.toPairs(repaymentEffectiveAmountByDate), ([repaymentEffectiveDateStr, totalRepaymentEffectiveAmount]) => {
        const repaymentEffectiveDate = common_1.date.strToFullDateStr(repaymentEffectiveDateStr, exports.parafinDateFormat);
        return {
            id: (0, uuid_1.v4)(),
            creditFacilityId,
            repaymentEffectiveDate,
            totalRepaymentEffectiveAmount,
            reportingDate,
            fileVersion,
        };
    });
    return lodash_1.default.map(dbRows, (row) => lodash_1.default.mapValues(row, common_1.utils.cleanStrForDb));
};
exports.repaymentFeedPointerMethod = repaymentFeedPointerMethod;
exports.repaymentTapePointerConfig = {
    pointer: 'parafinAtalaya1',
    method: exports.repaymentFeedPointerMethod,
};
//# sourceMappingURL=repaymentFeedPointerMethod.js.map